import * as types from './mutation-types'
export default {
    [types.SET_API_TOGGLE_INIT](state, { apiAction }) {
        state.api[apiAction].toggle.setInit();
    },
    [types.SET_API_TOGGLE_LOADING](state, { apiAction }) {
        state.api[apiAction].toggle.setLoading();
    },
    [types.SET_API_TOGGLE_SUCCESS](state, { apiAction }) {
        state.api[apiAction].toggle.setSuccess();
    },
    [types.SET_API_TOGGLE_FAIL](state, { apiAction }) {
        state.api[apiAction].toggle.setFail();
    },
    [types.SET_API_TOGGLE_EMPTY](state, { apiAction }) {
        state.api[apiAction].toggle.setEmpty();
    },
    [types.SET_API_DATA](state, { apiAction, data }) {
        state.api[apiAction].data = data;
    },
    [types.SET_URL_PARAMS](state, { urlParams }) {
        state.urlParams = urlParams;
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js